export const en = {
  'visitCalendar.minutes': '{m} min',
  'visitCalendar.hours': '{h} h',
  'visitCalendar.hoursMinutes': '{h} h {m} min',
  'visitCalendar.dayNone': '{date} · No visit',
  'visitCalendar.visits.one': '{count} visit',
  'visitCalendar.visits.other': '{count} visits',
  'visitCalendar.withoutExit.one': '{count} with no exit recorded',
  'visitCalendar.withoutExit.other': '{count} with no exit recorded',
  'visitCalendar.label': 'Visits over the last year: {count}. Use the arrow keys to move between days.',
  'visitCalendar.pick': 'Point at a day, or tap it, to see its visits.',
  'visitCalendar.shorter': 'Shorter',
  'visitCalendar.longer': 'Longer',
  'visitCalendar.title': 'Visits this year',
  'visitCalendar.hint': 'Each square is a day; the darker it is, the longer the stay from entry to exit.',
  'visitCalendar.noMembership': 'No membership',
  'visitCalendar.visitWithoutMembership': 'Visit with no membership',
  'visitCalendar.noVisit': 'No visit',
  'visitCalendar.timeInside': 'Time at the gym',
  'visitCalendar.visitsLabel': 'Visits',
  'visitCalendar.withoutExitLabel': 'No exit recorded',
  'visitCalendar.membership': 'Membership',
  'memberHome.greeting': 'Hi, {name}',
  'memberHome.manage': 'Manage',
  'memberHome.daysLeft.one': '{count} day left',
  'memberHome.daysLeft.other': '{count} days left',
  'memberHome.lastDay': 'Last day today',
  'memberHome.ofDays': 'of {total} days',
  'memberHome.healthLabel': 'Share of the membership left',
  'memberHome.started': 'Started {date}',
  'memberHome.ends': 'Ends {date}',
  'memberHome.startsOn': 'Starts {date}',
  'memberHome.renewsOn': 'Renews automatically on {date}',
  'memberHome.visitsLeft': '{left} of {limit} visits left',
  'memberHome.visitsLabel': 'Visits left on this membership',
  'memberHome.pausedSince': 'Paused since {date}. Your days stop running until you resume.',
  'memberHome.pending': 'This membership is waiting for its payment.',
  'memberHome.pendingCompany': 'Waiting for {company}’s payment.',
  'memberHome.checkPayments': 'Check payments',
  'memberHome.ended': 'This membership has ended.',
  'memberHome.noMembershipHint': 'Pick a plan to start training and booking classes.',
  'memberHome.memberNumber': 'Member #{number}',
  'memberHome.since': 'Member since {date}',
  'memberHome.balanceHint': 'Pay at the bar with your card',
  'memberHome.quick': 'Quick actions',
  'memberHome.bookClass': 'Book a class',
  'memberHome.topUp': 'Top up',
  'memberHome.visitsYear.one': '{count} visit in the last year',
  'memberHome.visitsYear.other': '{count} visits in the last year',
  'memberHome.noVisits': 'No visits yet. Your check-ins at the gym will fill this in.',
  'memberHome.quickLinks': 'Quick links',
  'memberHome.trainers': 'Trainers',
  'memberHome.noTrainers': 'No trainers to show yet.',
  'memberHome.hours': 'Opening hours',
  'memberHome.closed': 'Closed',
  'memberHome.barMenu': 'Bar menu',
  'memberHome.noMenu': 'The bar menu is empty for now.',
  'memberHome.streak': 'Streak',
  'memberHome.streakDays.one': '{count} day',
  'memberHome.streakDays.other': '{count} days',
  'memberHome.longest.one': 'Longest: {count} day',
  'memberHome.longest.other': 'Longest: {count} days',
  'memberHome.average': 'Average visit',
  'memberHome.averageHint': 'From entry to exit',
  'memberHome.totalTime': 'Time in the gym',
  'memberHome.activeDays.one': 'Over {count} day',
  'memberHome.activeDays.other': 'Over {count} days',
  'memberHome.usually': 'Usually',
  'memberHome.usuallyHint': 'Your busiest day and usual arrival',
  'memberHome.nextClasses': 'Next classes',
  'memberHome.all': 'All',
  'memberHome.noClasses': 'No upcoming classes',
  'memberHome.browseClasses': 'Browse classes',
  'memberHome.cards': 'Cards',
  'memberHome.cardsActive.one': '{count} active',
  'memberHome.cardsActive.other': '{count} active',
  'memberHome.lastUsed': 'Last used {when}',
  'memberHome.noCard': 'Ask the desk for a card',
  'memberHome.unread.one': '{count} unread',
  'memberHome.unread.other': '{count} unread',
  'memberHome.allRead': 'All read',
  'memberHome.toAccept.one': '{count} to accept',
  'memberHome.toAccept.other': '{count} to accept',
  'memberHome.allAccepted': 'All accepted',
  'memberHome.lastPayment': 'Last payment',
  'memberHome.noPayments': 'No payments yet',
  'memberHome.loadFailed': 'Could not load this.',
  'memberHome.inside': 'In the gym now',
  'memberHome.visitsWithoutExit.one': '{count} visit had no exit recorded, so its length is left out.',
  'memberHome.visitsWithoutExit.other': '{count} visits had no exit recorded, so their length is left out.',
};

export const ka: Record<keyof typeof en, string> = {
  'visitCalendar.minutes': '{m} წთ',
  'visitCalendar.hours': '{h} სთ',
  'visitCalendar.hoursMinutes': '{h} სთ {m} წთ',
  'visitCalendar.dayNone': '{date} · ვიზიტი არ ყოფილა',
  'visitCalendar.visits.one': '{count} ვიზიტი',
  'visitCalendar.visits.other': '{count} ვიზიტი',
  'visitCalendar.withoutExit.one': '{count} გასვლის აღრიცხვის გარეშე',
  'visitCalendar.withoutExit.other': '{count} გასვლის აღრიცხვის გარეშე',
  'visitCalendar.label': 'ვიზიტები ბოლო ერთი წლის განმავლობაში: {count}. დღეებს შორის გადასასვლელად გამოიყენეთ ისრები.',
  'visitCalendar.pick': 'მიიტანეთ კურსორი ან შეეხეთ დღეს, რომ ნახოთ მისი ვიზიტები.',
  'visitCalendar.shorter': 'მოკლე',
  'visitCalendar.longer': 'ხანგრძლივი',
  'visitCalendar.title': 'ვიზიტები ამ წელს',
  'visitCalendar.hint': 'თითოეული კვადრატი ერთი დღეა; რაც უფრო მუქია, მით უფრო დიდხანს გაგრძელდა ვიზიტი შესვლიდან გასვლამდე.',
  'visitCalendar.noMembership': 'აბონემენტის გარეშე',
  'visitCalendar.visitWithoutMembership': 'ვიზიტი აბონემენტის გარეშე',
  'visitCalendar.noVisit': 'ვიზიტი არ ყოფილა',
  'visitCalendar.timeInside': 'დარბაზში გატარებული დრო',
  'visitCalendar.visitsLabel': 'ვიზიტები',
  'visitCalendar.withoutExitLabel': 'გასვლა არ აღრიცხულა',
  'visitCalendar.membership': 'აბონემენტი',
  'memberHome.greeting': 'გამარჯობა, {name}',
  'memberHome.manage': 'მართვა',
  'memberHome.daysLeft.one': 'დარჩა {count} დღე',
  'memberHome.daysLeft.other': 'დარჩა {count} დღე',
  'memberHome.lastDay': 'დღეს ბოლო დღეა',
  'memberHome.ofDays': '{total} დღიდან',
  'memberHome.healthLabel': 'აბონემენტის დარჩენილი ნაწილი',
  'memberHome.started': 'დაიწყო {date}',
  'memberHome.ends': 'მთავრდება {date}',
  'memberHome.startsOn': 'იწყება {date}',
  'memberHome.renewsOn': 'ავტომატურად განახლდება {date}',
  'memberHome.visitsLeft': 'დარჩა {left} ვიზიტი {limit}-დან',
  'memberHome.visitsLabel': 'ამ აბონემენტზე დარჩენილი ვიზიტები',
  'memberHome.pausedSince': 'შეჩერებულია {date}-დან. დღეები არ იხარჯება, სანამ არ განაახლებთ.',
  'memberHome.pending': 'ეს აბონემენტი გადახდას ელოდება.',
  'memberHome.pendingCompany': 'ელოდება „{company}“-ის გადახდას.',
  'memberHome.checkPayments': 'გადახდების ნახვა',
  'memberHome.ended': 'ეს აბონემენტი დასრულდა.',
  'memberHome.noMembershipHint': 'აირჩიეთ აბონემენტი, რომ დაიწყოთ ვარჯიში და ჯგუფურ ვარჯიშებზე ჩაწერა.',
  'memberHome.memberNumber': 'წევრი #{number}',
  'memberHome.since': 'წევრი {date}-დან',
  'memberHome.balanceHint': 'გადაიხადეთ ბარში თქვენი ბარათით',
  'memberHome.quick': 'სწრაფი მოქმედებები',
  'memberHome.bookClass': 'ვარჯიშზე ჩაწერა',
  'memberHome.topUp': 'შევსება',
  'memberHome.visitsYear.one': '{count} ვიზიტი ბოლო ერთ წელიწადში',
  'memberHome.visitsYear.other': '{count} ვიზიტი ბოლო ერთ წელიწადში',
  'memberHome.noVisits': 'ვიზიტები ჯერ არ არის. დარბაზში თქვენი შესვლები აქ გამოჩნდება.',
  'memberHome.quickLinks': 'სწრაფი ბმულები',
  'memberHome.trainers': 'ტრენერები',
  'memberHome.noTrainers': 'საჩვენებელი ტრენერები ჯერ არ არის.',
  'memberHome.hours': 'სამუშაო საათები',
  'memberHome.closed': 'დაკეტილია',
  'memberHome.barMenu': 'ბარის მენიუ',
  'memberHome.noMenu': 'ბარის მენიუ ჯერ ცარიელია.',
  'memberHome.streak': 'სერია',
  'memberHome.streakDays.one': '{count} დღე',
  'memberHome.streakDays.other': '{count} დღე',
  'memberHome.longest.one': 'ყველაზე გრძელი: {count} დღე',
  'memberHome.longest.other': 'ყველაზე გრძელი: {count} დღე',
  'memberHome.average': 'საშუალო ვიზიტი',
  'memberHome.averageHint': 'შესვლიდან გასვლამდე',
  'memberHome.totalTime': 'დარბაზში გატარებული დრო',
  'memberHome.activeDays.one': '{count} დღის განმავლობაში',
  'memberHome.activeDays.other': '{count} დღის განმავლობაში',
  'memberHome.usually': 'ჩვეულებრივ',
  'memberHome.usuallyHint': 'თქვენი ყველაზე აქტიური დღე და ჩვეული მოსვლის დრო',
  'memberHome.nextClasses': 'მომდევნო ვარჯიშები',
  'memberHome.all': 'ყველა',
  'memberHome.noClasses': 'დაგეგმილი ვარჯიშები არ გაქვთ',
  'memberHome.browseClasses': 'ვარჯიშების ნახვა',
  'memberHome.cards': 'ბარათები',
  'memberHome.cardsActive.one': '{count} აქტიური',
  'memberHome.cardsActive.other': '{count} აქტიური',
  'memberHome.lastUsed': 'ბოლოს გამოყენებული {when}',
  'memberHome.noCard': 'ბარათი მიიღეთ რეცეფციაზე',
  'memberHome.unread.one': '{count} წაუკითხავი',
  'memberHome.unread.other': '{count} წაუკითხავი',
  'memberHome.allRead': 'ყველა წაკითხულია',
  'memberHome.toAccept.one': '{count} დასადასტურებელი',
  'memberHome.toAccept.other': '{count} დასადასტურებელი',
  'memberHome.allAccepted': 'ყველა დადასტურებულია',
  'memberHome.lastPayment': 'ბოლო გადახდა',
  'memberHome.noPayments': 'გადახდები ჯერ არ არის',
  'memberHome.loadFailed': 'ვერ ჩაიტვირთა.',
  'memberHome.inside': 'ახლა დარბაზში ხართ',
  'memberHome.visitsWithoutExit.one': '{count} ვიზიტს გასვლა არ აქვს აღრიცხული, ამიტომ მისი ხანგრძლივობა არ ითვლება.',
  'memberHome.visitsWithoutExit.other': '{count} ვიზიტს გასვლა არ აქვს აღრიცხული, ამიტომ მათი ხანგრძლივობა არ ითვლება.',
};
